export default __webpack_public_path__ + "static/media/problema-03.a44caa4d.webp";